import { Skills } from '@/lib/types'
import { Badge } from '@/ui'
import { useTranslation } from '@/i18n'

interface BadgeListProps {
  skills: Skills
}

export function BadgeList({ skills }: BadgeListProps) {
  const { t } = useTranslation()

  return (
    <section className="py-8 px-4">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl font-bold mb-6 dark:text-gray-100">{t('skills.title')}</h2>

        {skills.groups.map((group) => (
          <div key={group.id} className="mb-8">
            <h3 className="text-xl font-semibold mb-4 dark:text-gray-200">{group.title}</h3>
            <div className="flex flex-wrap gap-3">
              {group.items.map((skill, i) => (
                <Badge key={i} variant="primary" size="md">
                  {skill.name}
                </Badge>
              ))}
            </div>
          </div>
        ))}

        {/* Soft Skills */}
        {skills.soft_skills && skills.soft_skills.length > 0 && (
          <div className="mt-8">
            <h3 className="text-xl font-semibold mb-4 dark:text-gray-200">
              {t('skills.softSkills')}
            </h3>
            <div className="flex flex-wrap gap-3">
              {skills.soft_skills.map((skill, i) => (
                <Badge key={i} variant="default" size="md">
                  {skill}
                </Badge>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  )
}
